<template>
    <span
        class="rounded-3xl px-3 py-1 inline-flex flex items-center justify-center space-x-2"
        :class="color"
    >
        <slot name="leftIcon" />
        <p
            class="text-sm font-semibold"
            :class="textColor"
        >
            {{ text }}
        </p>
        <slot name="rightIcon" />
        <template v-if="forwardIcon">
            <ChevronRightIcon 
                class="w-4 h-4"
                :class="textColor"
            />
        </template>
    </span>
</template>

<script setup lang="ts">
import { ChevronRightIcon } from "@heroicons/vue/24/solid";
defineProps({
    color: {
        type: String,
        default: "black",
    },
    text: {
        type: String,
        required: true,
    },
    textColor: {
        type: String,
        default: "white",
    },
    forwardIcon: {
        type: Boolean,
        default: false,
    },
});
</script>